module.exports = __webpack_public_path__ + "static/media/refund.f0b23d3d.svg";